import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  BarChart,
  LineChart,
  BarChartSizes,
  DashboardCard,
} from "../../common";
import {
  E_ContractType,
  StatisticTypeWidget,
  StatisticWidgetVariantValue,
} from "../../common/types";
import { StatisticWidget, Table, CalendarDemo } from "../../common";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import "./MainDashboard.css";
import { FormattedMessage, useIntl } from "react-intl";
import { DashboardServices } from "../../../services";
import { StorageServices } from "../../../services";

const MainDashboard = () => {
  const [Recommended, setRecommended] = useState<any[]>();
  const [SizeGuideRecommended, setSizeGuideRecommended] = useState<any>();
  const [SizesGuideRecommended, setSizesGuideRecommended] = useState<any[]>([]);
  const [DaysRecommended, setDaysRecommended] = useState<any[]>();
  const [AgeRecommended, setAgeRecommended] = useState<any[]>();
  const [isLoadingRecommended, setIsLoadingRecommended] = useState(false);
  const [isLoadingSizeGuideRecommended, setIsLoadingSizeGuideRecommended] =
    useState(false);
  const [isLoadingDaysRecommended, setIsLoadingDaysRecommended] =
    useState(false);
  const [isLoadingAgeRecommended, setIsLoadingAgeRecommended] = useState(false);
  const [isLoadingSizesGuideRecommended, setIsLoadingSizesGuideRecommended] =
    useState(false);
  const [dateSelected, setDateSelected] = useState<any[]>([
    new Date(new Date().setDate(new Date().getDate() - 6))
      .toISOString()
      .substring(0, 10),
    new Date().toISOString().substring(0, 10),
  ]);
  const [sizeGuideIdSelected, setsizeGuideIdSelected] = useState(0);
  const [contractType, setContractType] = useState(E_ContractType.NONE);

  useEffect(() => {
    const user = StorageServices.GetCookieUser();
    const contractType =
      user?.Contract?.Name === "Free"
        ? E_ContractType.FREE
        : E_ContractType.NONE;
    setContractType(contractType);
    loadDashboard();
  }, []);

  const intl = useIntl();

  const loadDashboard = (
    dateFrom: string | "" = "",
    dateTo: string | "" = "",
    sizeGuideId: number | undefined = 0
  ) => {
    (async () => {
      try {
        setIsLoadingRecommended(true);

        const response = await DashboardServices.GetRecommended(
          dateFrom,
          dateTo
        );

        if (response.Status === 200) {
          setRecommended(response.Content);
        } else {
          setRecommended([]);
        }

        setIsLoadingRecommended(false);
      } catch (error) {
        console.log(error);

        setIsLoadingRecommended(false);
      }
    })();

    (async () => {
      try {
        setIsLoadingSizeGuideRecommended(true);

        const getRecommended =
          await DashboardServices.GetRecommendedSizePerSizeGuide(
            dateFrom,
            dateTo,
            sizeGuideId
          );

        if (getRecommended && getRecommended.Status === 200) {
          setSizeGuideRecommended(getRecommended.Content);
        } else {
          setSizeGuideRecommended({});
        }

        setIsLoadingSizeGuideRecommended(false);
      } catch (error) {
        console.log(error);

        setIsLoadingSizeGuideRecommended(false);
      }
    })();

    (async () => {
      try {
        setIsLoadingDaysRecommended(true);

        const getRecommended = await DashboardServices.GetRecommendedPerDays(
          dateFrom,
          dateTo
        );

        if (getRecommended && getRecommended.Status === 200) {
          setDaysRecommended(getRecommended.Content);
        } else {
          setDaysRecommended([]);
        }

        setIsLoadingDaysRecommended(false);
      } catch (error) {
        console.log(error);

        setIsLoadingDaysRecommended(false);
      }
    })();

    (async () => {
      try {
        setIsLoadingAgeRecommended(true);

        const getRecommended = await DashboardServices.GetRecommendedPerAge(
          dateFrom,
          dateTo
        );

        if (getRecommended && getRecommended.Status === 200) {
          setAgeRecommended(getRecommended.Content);
        } else {
          setAgeRecommended([]);
        }

        setIsLoadingAgeRecommended(false);
      } catch (error) {
        console.log(error);

        setIsLoadingAgeRecommended(false);
      }
    })();

    (async () => {
      try {
        setIsLoadingSizesGuideRecommended(true);

        const getRecommended =
          await DashboardServices.GetRecommendedPerSizesGuide(dateFrom, dateTo);

        if (getRecommended && getRecommended.Status === 200) {
          setSizesGuideRecommended(getRecommended.Content);
        } else {
          setSizesGuideRecommended([]);
        }

        setIsLoadingSizesGuideRecommended(false);
      } catch (error) {
        console.log(error);

        setIsLoadingSizesGuideRecommended(false);
      }
    })();
  };

  const loadDashboardSizeGuide = (
    dateFrom: string | "" = "",
    dateTo: string | "" = "",
    sizeGuideId: number | undefined = 0
  ) => {
    (async () => {
      try {
        setIsLoadingSizeGuideRecommended(true);

        const getRecommended =
          await DashboardServices.GetRecommendedSizePerSizeGuide(
            dateFrom,
            dateTo,
            sizeGuideId
          );

        if (getRecommended && getRecommended.Status === 200) {
          setSizeGuideRecommended(getRecommended.Content);
        } else {
          setSizeGuideRecommended({});
        }

        setIsLoadingSizeGuideRecommended(false);
      } catch (error) {
        console.log(error);

        setIsLoadingSizeGuideRecommended(false);
      }
    })();
  };

  useEffect(() => {
    loadDashboard();
  }, [
    setRecommended,
    setSizeGuideRecommended,
    setDaysRecommended,
    setAgeRecommended,
  ]);

  const CalculatePercentaje = (
    base: number,
    total: number,
    rounded: number | undefined = -1
  ) => {
    try {
      if (rounded < 0) {
        return Math.floor(((base * 1.0) / (total * 1.0)) * 100);
      } else {
        return Math.ceil(((base * 1.0) / (total * 1.0)) * 100);
      }
    } catch (e) {
      console.log("CalculatePercentaje", e);

      return 0;
    }
  };

  const onChangeDates = (value: any) => {
    /*        console.log('onChangeDates', value);*/

    try {
      if (value && value[0] && value[1]) {
        const dateFrom: Date = new Date(value[0]);
        const dateTo: Date = new Date(value[1]);

        loadDashboard(
          dateFrom.toISOString().substring(0, 10),
          dateTo.toISOString().substring(0, 10),
          sizeGuideIdSelected
        );
        //console.log('onChangeDates', dateFrom.toISOString().substring(0, 10));
        //console.log('onChangeDates', dateTo.toISOString().substring(0, 10));

        setDateSelected([
          dateFrom.toISOString().substring(0, 10),
          dateTo.toISOString().substring(0, 10),
        ]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onChangeSizeGuide = (value: any) => {
    try {
      if (value) {
        loadDashboardSizeGuide(dateSelected[0], dateSelected[1], value);

        setsizeGuideIdSelected(value);
        //console.log('onChangeDates', dateFrom.toISOString().substring(0, 10));
        //console.log('onChangeDates', dateTo.toISOString().substring(0, 10));
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div>
      {/* RESULTADOS 7 DIAS */}
      <div className="top-dashboard-container">
        <h4 className="dashboard-main-title">
          <FormattedMessage
            id="ready-size-statistics"
            defaultMessage="Estadísticas"
          />
        </h4>
        <h5 className="dashboard-main-p">
          <FormattedMessage id="main-dashboard-subtitle" />
        </h5>
        <div className="fecha-botones-descarga">
          <div className="fecha-calendar">
            <p className="dashboard-calendar-p">
              {" "}
              <FormattedMessage id="main-dashboard-date" />
            </p>
            <CalendarDemo
              SuscribedChange={(value: any) => onChangeDates(value)}
            />
            {/*<div className="dashboard-botones">*/}
            {/*    <div className="dashboard-buttons-container">*/}
            {/*    <button className="btn-dashboard">*/}
            {/*        {" "}*/}
            {/*        <FormattedMessage*/}
            {/*        id="main-dashboard-all"*/}
            {/*        defaultMessage="Todos ({value})"*/}
            {/*        values={{ value: Number(2) }}*/}
            {/*        />*/}
            {/*    </button>*/}
            {/*    <button className="btn-dashboard">*/}
            {/*        <FormattedMessage*/}
            {/*        id="main-dashboard-female"*/}
            {/*        defaultMessage="Femenino ({value})"*/}
            {/*        values={{ value: Number(1) }}*/}
            {/*        />*/}
            {/*    </button>*/}
            {/*    <button className="btn-dashboard">*/}
            {/*        <FormattedMessage*/}
            {/*        id="main-dashboard-male"*/}
            {/*        defaultMessage="Masculino ({value})"*/}
            {/*        values={{ value: Number(3) }}*/}
            {/*        />*/}
            {/*    </button>*/}
            {/*    <button className="btn-dashboard">*/}
            {/*        <FormattedMessage*/}
            {/*        id="main-dashboard-brassieres"*/}
            {/*        defaultMessage="Sostenes ({value})"*/}
            {/*        values={{ value: Number(4) }}*/}
            {/*        />*/}
            {/*    </button>*/}
            {/*    </div>*/}
            {/*</div>*/}
          </div>
          {/*<div className="dashboard-descarga">*/}
          {/*    <div className="dashboard-modal-component">*/}
          {/*        <FontAwesomeIcon*/}
          {/*        className="dashboard-descarga-icon"*/}
          {/*        icon={faArrowDown}*/}
          {/*        />*/}
          {/*    </div>*/}
          {/*    <div>*/}
          {/*        <h2 className="dashboard-descarga-h2">*/}
          {/*        <p className="dashboard-descarga-h2-p">*/}
          {/*            {" "}*/}
          {/*            <FormattedMessage*/}
          {/*            id="main-dashboard-download"*/}
          {/*            defaultMessage="Descargar ({value})"*/}
          {/*            values={{ value: Number(0) }}*/}
          {/*            />{" "}*/}
          {/*        </p>*/}
          {/*        </h2>*/}
          {/*    </div>*/}
          {/*</div>*/}
        </div>
      </div>

      {/* WIDGETS CON EMOTICONES */}
      <div className="widgets">
        <Row className="justify-content-center mt-2 px-3">
          <Col xs={8} xl={9} className="widgets-container">
            <Row>
              <Col>
                <StatisticWidget
                  text="ready-size-recommended-sizes"
                  value={
                    <>
                      {Recommended && Recommended[0] && Recommended[0].Value
                        ? Recommended[0].Value
                        : "0"}
                      {contractType === E_ContractType.FREE && (
                        <span className="smaller-font"> / 500</span>
                      )}
                    </>
                  }
                  valueVariant={StatisticWidgetVariantValue.REGULAR}
                  typeWidget={StatisticTypeWidget.SUNGLASSES}
                  contractType={contractType}
                />
              </Col>
              <Col className="mx-3">
                <StatisticWidget
                  text={"ready-size-found-size"}
                  helper="home-widget-found-helper"
                  value={
                    !isLoadingRecommended
                      ? `${
                          Recommended && Recommended[0] && Recommended[0].Value
                            ? CalculatePercentaje(
                                Recommended[1].Value,
                                Recommended[0].Value,
                                1
                              )
                            : "0"
                        }%`
                      : "0%"
                  }
                  valueVariant={StatisticWidgetVariantValue.SUCCESS}
                  typeWidget={StatisticTypeWidget.STARSTRUCK}
                  contractType={contractType}
                />
              </Col>
              <Col>
                <StatisticWidget
                  text={"ready-size-didnt-found-size"}
                  helper="home-widget-didnt-find-helper"
                  value={
                    !isLoadingRecommended
                      ? `${
                          Recommended && Recommended[0] && Recommended[0].Value
                            ? CalculatePercentaje(
                                Recommended[2].Value,
                                Recommended[0].Value,
                                -1
                              )
                            : "0"
                        }%`
                      : "0%"
                  }
                  valueVariant={StatisticWidgetVariantValue.DANGER}
                  typeWidget={StatisticTypeWidget.FROWNING}
                  contractType={contractType}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      {/* CUADROS ESTADISTICA */}
      <div className="stats">
        <Row className="stats-card-one mt-4 justify-content-center">
          <Col className="dashboard-charts-containers" xs={3}>
            <BarChartSizes
              bgClass={"bg-danger-fitprenda"}
              title={intl.formatMessage({
                id: "main-dashboard-mostRecommendedSizes",
                defaultMessage: "Talles más recomendados",
              })}
              className="dashboard-charts"
              DataValue={
                !isLoadingSizeGuideRecommended ? SizeGuideRecommended : {}
              }
              SuscribedChange={(value: any) => onChangeSizeGuide(value)}
            />
          </Col>

          <Col className="dashboard-charts-containers" xs={3}>
            <LineChart
              bgClass={"bg-warning-fitprenda"}
              title={intl.formatMessage({
                id: "main-dashboard-recommendedSizesPerDay",
                defaultMessage: "Talles recomendados por día",
              })}
              className="dashboard-charts"
              DataValue={!isLoadingDaysRecommended ? DaysRecommended : []}
            />
          </Col>

          <Col className="dashboard-charts-containers" xs={3}>
            <BarChart
              bgClass={"bg-warning-fitprenda"}
              title={intl.formatMessage({
                id: "main-dashboard-userAge",
                defaultMessage: "Edad de los usuarios",
              })}
              className="dashboard-charts"
              DataValue={!isLoadingAgeRecommended ? AgeRecommended : []}
            />
          </Col>
        </Row>
      </div>

      {/* LAS CARDS */}
      {/* <div className="dashboard-cards">
        <Row>
          <Col>
            <DashboardCard
              title={intl.formatMessage({
                id: "main-dashboard-searchedFemaleClothes",
              })}
              percentage="72%"
              edad="42"
              peso="64"
              altura="1,66"
              largo="82"
              cintura="65"
              cadera="73"
              busto="68"
              largoPie="34"
              img="img/icon-sizeguide-female-bottom-half.png"
            />
          </Col>
          <Col>
            <DashboardCard
              title={intl.formatMessage({
                id: "main-dashboard-searchedMaleClothes",
              })}
              percentage="28%"
              edad="37"
              peso="75"
              altura="1,72"
              largo="1,05"
              cintura="67"
              cadera="72"
              busto="59"
              largoPie="34"
              img="img/icon-sizeguide-male-bottom-half.png"
            />
          </Col>
        </Row>
      </div> */}

      {/* TABLA */}
      <div className="main-dashboard-table">
        {contractType === E_ContractType.FREE ? (
          <img src="img/dashresults.png" alt="" />
        ) : (
          <Table
            isLoadingData={isLoadingSizesGuideRecommended}
            Data={SizesGuideRecommended}
          />
        )}
      </div>
    </div>
  );
};

export default MainDashboard;
